// extracted by mini-css-extract-plugin
module.exports = {"root":"Message_root__I4u4H","text":"Message_text___gl6s","icon":"Message_icon__gk9MR"};